import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  TextField,
} from "@mui/material";
// @ts-ignore
import { ResizableBox, ResizableCallbackData } from "react-resizable";
import "react-resizable/css/styles.css";
import { useRecoilValue } from "recoil";
import { warehousesState } from "../../recoil/atoms/warehousesAtoms";
import { ResponseGetWarehouseResponse } from "../../services/OpenAPI";

type Props = {
  checkedIds: Set<string>;
  onCheckedChange: (id: string) => void;
  onCheckedChangeAll: (checkedIds: Set<string>) => void;
};

const WarehouseTable: React.FC<Props> = ({
  checkedIds,
  onCheckedChange,
  onCheckedChangeAll,
}) => {
  const warehouseList = useRecoilValue(warehousesState);

  // フィルター条件
  const [filters, setFilters] = useState<Partial<ResponseGetWarehouseResponse>>(
    {}
  );
  const [columnWidths, setColumnWidths] = useState<number[]>([
    30, // チェックボックス
    80, // コード
    150, // 名称
    70, // 郵便番号
    200, // 所在地
  ]);

  // フィルター条件の更新
  const handleFilterChange = (
    key: keyof ResponseGetWarehouseResponse | "code",
    value: string
  ) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // フィルタリング
  const filteredWarehouses = warehouseList?.filter((warehouse) => {
    return Object.entries(filters).every(([key, value]) => {
      if (!value) return true;
      let targetValue = "";
      if (key === "code") {
        targetValue = (warehouse.code1 ?? "") + (warehouse.code2 ?? "");
      } else {
        const targetValue =
          warehouse[key as keyof ResponseGetWarehouseResponse] ?? "";
        return String(targetValue).includes(String(value));
      }
      return String(targetValue).includes(String(value));
    });
  });

  // 列幅更新
  const handleResize = (index: number, newWidth: number) => {
    const updated = [...columnWidths];
    updated[index] = newWidth;
    setColumnWidths(updated);
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "100%",
        maxWidth: "100%",
        overflow: "auto",
        height: "calc(100vh - 80px)",
        overflowY: "auto",
        overflowX: "auto",
      }}
    >
      <Table size="small" stickyHeader sx={{ minWidth: 1200 }}>
        <TableHead>
          {/* ヘッダー行 */}
          <TableRow>
            <TableCell align="center" sx={{ width: 20, padding: 0 }}>
              <Checkbox
                checked={
                  checkedIds.size === filteredWarehouses?.length &&
                  filteredWarehouses?.length > 0
                }
                indeterminate={
                  checkedIds.size > 0 &&
                  checkedIds.size < filteredWarehouses!.length
                }
                onChange={(e) => {
                  const checked = e.target.checked;
                  if (checked) {
                    const newSet = new Set(
                      filteredWarehouses?.map((warehouse) =>
                        String(warehouse.id)
                      )
                    );
                    console.log(newSet);
                    onCheckedChangeAll(newSet);
                  } else {
                    onCheckedChangeAll(new Set());
                  }
                }}
              />
            </TableCell>
            {["コード", "名称", "郵便番号", "所在地"].map((label, idx) => (
              <TableCell
                key={label}
                align="center"
                style={{ width: columnWidths[idx + 1], whiteSpace: "nowrap" }}
              >
                <ResizableBox
                  width={columnWidths[idx + 1]}
                  height={30}
                  axis="x"
                  resizeHandles={["e"]}
                  onResizeStop={(_: unknown, data: ResizableCallbackData) => {
                    handleResize(idx + 1, data.size.width);
                  }}
                >
                  <div
                    style={{
                      width: columnWidths[idx + 1],
                      textAlign: "center",
                    }}
                  >
                    {label}
                  </div>
                </ResizableBox>
              </TableCell>
            ))}
          </TableRow>

          {/* フィルター行 */}
          <TableRow>
            <TableCell />
            <TableCell>
              <TextField
                variant="standard"
                placeholder="フィルター"
                fullWidth
                onChange={(e) => handleFilterChange("code", e.target.value)}
              />
            </TableCell>
            <TableCell>
              <TextField
                variant="standard"
                placeholder="フィルター"
                fullWidth
                onChange={(e) => handleFilterChange("name", e.target.value)}
              />
            </TableCell>
            <TableCell>
              <TextField
                variant="standard"
                placeholder="フィルター"
                fullWidth
                onChange={(e) =>
                  handleFilterChange("postalCode", e.target.value)
                }
              />
            </TableCell>
            <TableCell>
              <TextField
                variant="standard"
                placeholder="フィルター"
                fullWidth
                onChange={(e) => handleFilterChange("address", e.target.value)}
              />
            </TableCell>
          </TableRow>
        </TableHead>

        {/* データ行 */}
        <TableBody>
          {filteredWarehouses?.map((warehouse) => (
            <TableRow
              key={warehouse.id}
              // onClick={() => {
              //   onRowClick(warehouse);
              // }}
            >
              <TableCell align="center" onClick={(e) => e.stopPropagation()}>
                <Checkbox
                  checked={checkedIds.has(String(warehouse.id))}
                  onChange={(e) => {
                    e.stopPropagation();
                    console.log(warehouse.id);
                    onCheckedChange(String(warehouse.id));
                  }}
                />
              </TableCell>
              <TableCell>
                {(warehouse.code1 ?? "") + (warehouse.code2 ?? "")}
              </TableCell>
              <TableCell>{warehouse.name}</TableCell>
              <TableCell>{warehouse.postalCode}</TableCell>
              <TableCell>{warehouse.address}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default WarehouseTable;
